module.exports = __webpack_public_path__ + "img/slide-40.398bc165.jpeg";